import React, { Component, Fragment } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import Pagination from "../Pagination/Pagination";
import Dialog from "../Dialog/Dialog";
import Filter from "../Filter/Filter";
import PrintOrders from "./PrintOrders/PrintOrders";
import withRouter from "../withRouter/withRouter";
import { toPersianNumber } from "../../classes/utils";
import { setupNotifications } from "../setupNotifications";

import "./Orders.css";

class Orders extends Component {
    state = {
        ordersToShow: null,
        count: 5,
        page: 0,
        filters: null,
        total: null,
        contact_info: null,
        dialog: null,
        subscribed: null,
    };
    constructor(props) {
        super(props);
        this.printOrder = this.printOrder.bind(this);
        this.request_data = this.request_data.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.print_not_printed_orders =
            this.print_not_printed_orders.bind(this);
        this.on_page_change = this.on_page_change.bind(this);
        this.update_order_status = this.update_order_status.bind(this);
        this.deletOrder = this.deletOrder.bind(this);
        this.verify_online_payment = this.verify_online_payment.bind(this);
        this.decode_URI = this.decode_URI.bind(this);
        this.generate_query = this.generate_query.bind(this);
        this.parse_query = this.parse_query.bind(this);
        this.subscribe_notifs = this.subscribe_notifs.bind(this);
        this.get_notifs_subs_status = this.get_notifs_subs_status.bind(this);
    }
    submittedUrl = null;

    componentDidMount() {
        let { toast, connection } = this.props;
        connection
            .get_contact_info()
            .then((res) => {
                this.setState({ contact_info: res.data });
            })
            .catch((err) => {
                toast(
                    "دریافت اطلاعات پستی فروشگاه",
                    "خطا در دریافت اطلاعات پستی فروشگاه " + err,
                    " danger"
                );
            });

        this.get_notifs_subs_status();

        this.decode_URI();
    }

    componentDidUpdate() {
        this.submittedUrl !=
            decodeURIComponent(this.props.router.location.search) &&
            this.decode_URI();
    }

    on_page_change(page) {
        this.setState({ page }, () => {
            this.props.router.navigate("/orders" + this.generate_query());
        });
    }

    parse_query(query) {
        let res = {};

        if (!query || typeof query != "string") return null;
        query = query.split("&");

        if (query.length < 1) return null;
        query[0] = query[0].replace("?", "");

        query.forEach((q) => {
            q = q.split("=");
            res[decodeURIComponent(q[0])] =
                q.length > 1 ? decodeURIComponent(q[1]) : "";
        });
        return res;
    }

    decode_URI() {
        this.submittedUrl = decodeURIComponent(
            this.props.router.location.search
        );

        let query = decodeURIComponent(this.props.router.location.search);
        query = this.parse_query(query) || {};
        let { page, count } = query;

        query && delete query.page;
        query && delete query.count;

        this.setState(
            {
                filters: query,
                page: parseInt(page) || 0,
                count: parseInt(count) || 15,
            },
            () => {
                this.request_data();
            }
        );
    }

    async get_notifs_subs_status() {
        this.props.connection
            .is_notifications_subscribed()
            .then((res) => {
                this.setState({ subscribed: true });
            })
            .catch((err) => {
                this.setState({ subscribed: false });
            });
    }

    generate_query() {
        let { filters, page, count } = this.state;

        let query = filters || {};
        count && (query.count = count);
        page > -1 && (query.page = page);

        let queryKeys = query && Object.keys(query);
        return (
            "?" +
            queryKeys
                .filter((k) => {
                    return (
                        query[k] &&
                        (Array.isArray(query[k])
                            ? query[k].length > 0
                                ? k
                                : null
                            : k)
                    );
                })
                .map((k) => {
                    return (
                        k +
                        "=" +
                        (typeof query[k] === "string"
                            ? query[k]
                            : JSON.stringify(query[k]))
                    );
                })
                .join("&")
        );
    }

    onFilterChange(filters) {
        this.setState({ filters }, () => {
            this.props.router.navigate("/orders" + this.generate_query());
        });
    }

    request_data() {
        let { toast, connection } = this.props;
        let { filters, page, count } = this.state;
        filters = filters || {};
        filters.reverseSort === undefined && (filters.reverseSort = true);
        let statuses = [];
        filters.sent && statuses.push('"sent"') && delete filters.sent;
        filters.notPayed &&
            statuses.push('"notPayed"') &&
            delete filters.notPayed;
        filters.pending && statuses.push('"pending"') && delete filters.pending;
        statuses.length > 0 && (filters.status = `[${statuses.join(",")}]`);

        filters.search == "" && delete filters.search;

        (filters.notPrinted && (filters.printed = false)) ||
            (true && delete filters.notPrinted);

        connection
            .get_filtered_data(
                "orders",
                JSON.parse(JSON.stringify(filters)),
                null,
                count,
                null,
                page
            )
            .then((res) => {
                let { orders, total, page } = res.data;

                this.setState({ ordersToShow: orders, total, page });
            })
            .catch((err) => {
                toast("خطا در دریافت سفارشات", " خطای : " + err, " danger");
            });
    }

    printOrder(order) {
        const _window = (
            <PrintOrders
                orders={[order]}
                contact_info={this.state.contact_info}
            />
        );
        var prinTab = window.open();
        prinTab.document.write(renderToStaticMarkup(_window));
        prinTab.document.close();
        prinTab.print();
    }

    deletOrder(id, freeUp) {
        let { toast, connection } = this.props;

        this.setState({
            dialog: (
                <Dialog
                    message={"آیا میخواهید این سفارش را حذف کنید؟"}
                    actions={[
                        {
                            text: "بله",
                            callback: (e) => {
                                connection
                                    .delet_order(id, freeUp)
                                    .then((res) => {
                                        toast(
                                            "حذف سفارش",
                                            "سفارش حذف شد",
                                            " confirm"
                                        );
                                        this.request_data();
                                    })
                                    .catch((err) => {
                                        toast(
                                            "حذف سفارش",
                                            "خطا در حذف سفارش " + err,
                                            " danger"
                                        );
                                    })
                                    .finally((ev) => {
                                        this.setState({ dialog: null });
                                    });
                            },
                            classes: "btn btn-sm danger",
                        },
                        {
                            text: "خیر",
                            callback: (e) => {
                                this.setState({ dialog: null });
                            },
                            classes: "btn btn-sm confirm",
                        },
                    ]}
                />
            ),
        });
    }

    print_not_printed_orders() {
        let { toast, connection } = this.props;
        connection
            .print_not_printed_orders()
            .then((res) => {
                const orders = res.data;
                if (!orders || orders.length === 0) {
                    toast(
                        "چاپ سفارش ها",
                        "هیچ سفارش کامل شده ی چاپ نشده ای وجود ندارد",
                        " warning",
                        10000
                    );

                    return;
                }
                const _window = (
                    <PrintOrders
                        orders={orders}
                        contact_info={this.state.contact_info}
                    />
                );
                var prinTab = window.open();
                prinTab.document.write(renderToStaticMarkup(_window));
                prinTab.document.close();
                prinTab.print();
            })
            .catch((err) => {
                console.log(err);
            });
    }

    update_order_status(order, tracking_Code) {
        let { connection, toast } = this.props;

        connection
            .update_order_status(order, tracking_Code)
            .then((res) => {
                toast(
                    "بروز رسانی سفارش",
                    "سفارش با موفقیت بروزرسانی شد",
                    " confirm"
                );
                let newOrder = res.data;
                let { ordersToShow: orders } = this.state;
                let index = orders.findIndex((o) => {
                    return o.id == newOrder.id;
                });
                orders[index] = newOrder;

                this.setState({ ordersToShow: orders });
            })
            .catch((err) => {
                toast(
                    "خطا در ارسال اطلاعات",
                    "بروزرسانی سفارش با خطا مواجه شد.",
                    " danger"
                );
            });
    }

    verify_online_payment(id) {
        let { connection, toast } = this.props;
        connection
            .verify_online_payment(id)
            .then((res) => {
                console.log(toast);
                toast(
                    "استعلام تراکنش",
                    `تراکنش ${id} معتبر است و انجام شده است.`,
                    " confirm"
                );
            })
            .catch((err) => {
                console.log(err);
                toast(
                    "استعلام تراکنش",
                    `تراکنش  ${id}  نا معتبر است و انجام نشده است.`,
                    " danger"
                );
            });
    }

    async subscribe_notifs() {
        const { toast, connection } = this.props;
        if (this.state.subscribed !== null) {
            if (this.state.subscribed) {
                connection
                    .unsubscribe_notifications()
                    .then((result) => {
                        toast("آگاه ساز", "با موفقیت غیر فعال شد.", " confirm");
                        this.get_notifs_subs_status();
                    })
                    .catch((err) => {
                        console.log(err);

                        toast(
                            "آگاه ساز",
                            "خطا در غیر فعالسازی آگاه ساز : " +
                                err.response?.message ||
                                err.message ||
                                err,
                            " danger"
                        );
                    });
            } else {
                setupNotifications(connection)
                    .then((result) => {
                        toast("آگاه ساز", "با موفقیت فعال شد.", " confirm");
                        this.get_notifs_subs_status();
                    })
                    .catch((err) => {
                        console.log(err);
                        toast(
                            "آگاه ساز",
                            "خطا در فعالسازی آگاه ساز : " +
                                err.response?.message ||
                                err.message ||
                                err,
                            " danger"
                        );
                    });
            }
        }
    }

    render() {
        let { ordersToShow, count, total, page, dialog, filters, subscribed } =
            this.state;
        filters = filters || {};
        let tracking_code = "";
        return (
            <div className='OrdersComponentContainer'>
                <Filter
                    filters={[
                        {
                            label: "پرداخت نشده",
                            value: "notPayed",
                            default: filters.notPayed,
                        },
                        {
                            label: "در حال انجام",
                            value: "pending",
                            default: filters.pending,
                        },
                        {
                            label: "ارسال شده",
                            value: "sent",
                            default: filters.sent,
                        },
                        {
                            label: "پرینت گرفته نشده",
                            value: "notPrinted",
                            default: filters.notPrinted,
                        },
                    ]}
                    defaultSearch={filters.search}
                    onFilterChange={this.onFilterChange}
                />
                {dialog}
                <button
                    className='btn confirm'
                    onClick={this.print_not_printed_orders}
                >
                    پرینت تمام سفارشات پرینت گرفته نشده
                </button>
                <button
                    className={`btn m-4 ${
                        subscribed === null
                            ? "Warning"
                            : subscribed
                            ? "danger"
                            : "confirm"
                    }`}
                    onClick={this.subscribe_notifs}
                >
                    {subscribed === null
                        ? "دریافت وضعیت آگاهسازی"
                        : subscribed
                        ? "غیر فعالسازی نوتیفیکیشن ها"
                        : "فعالسازی نوتیفیکیشن ها"}
                </button>
                <div className='ordersWraper'>
                    {ordersToShow &&
                        ordersToShow.length > 0 &&
                        ordersToShow.map((o) => {
                            return (
                                <div
                                    className={"orderRow " + o.status}
                                    key={o.id}
                                >
                                    <div className='top'>
                                        <div className='costumerDetail'>
                                            <div className='id'>{o.id}</div>
                                            <div className='costumerName'>
                                                <a className='text primary'>
                                                    {o.name}
                                                </a>
                                            </div>
                                            <div className='costumerMobile text info'>
                                                {o.mobile}
                                            </div>
                                            <div className='coupon '>
                                                {o.coupon &&
                                                    o.coupon.coupon && (
                                                        <a
                                                            className='text secondary'
                                                            href={
                                                                "/coupon/code/" +
                                                                o.coupon.coupon
                                                            }
                                                        >
                                                            {" "}
                                                            {`کد تخفیف : ${o.coupon.coupon}`}
                                                        </a>
                                                    )}
                                            </div>
                                            <div className='costumerAddress'>
                                                {`${o.province_name} - ${o.city_name} - ${o.address}`}
                                            </div>
                                            <div className='costumerPostalCode'>
                                                {toPersianNumber(o.zip)}
                                            </div>
                                            <div className='postMethod'>
                                                {o.shipping === "post"
                                                    ? "پست"
                                                    : o.shipping === "tipax"
                                                    ? "تیپاکس"
                                                    : o.shipping === "freight"
                                                    ? "پست - پس کرایه"
                                                    : " نوع ارسال نا مشخص ؟"}
                                            </div>
                                            <div className='note'>
                                                {o.comment}
                                            </div>
                                        </div>
                                        <div className='items'>
                                            {o.items.map((i, itemIndex) => {
                                                return (
                                                    <div
                                                        className='itemRow'
                                                        key={itemIndex}
                                                    >
                                                        <div className='name '>
                                                            <a
                                                                className=' text secondary'
                                                                href={
                                                                    "/items/" +
                                                                    i.id
                                                                }
                                                            >
                                                                {i.name}
                                                            </a>
                                                        </div>
                                                        <div className='color text info'>
                                                            {i.color.name}
                                                        </div>
                                                        <div className='amount text info'>
                                                            {toPersianNumber(
                                                                i.amount
                                                            )}
                                                            {i.unit}
                                                        </div>
                                                        <div className='total text primary'>
                                                            {toPersianNumber(
                                                                o.check[
                                                                    itemIndex
                                                                ].price,
                                                                true
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })}

                                            <div className='totalOrderCost text primary'>
                                                <div className='text info'>
                                                    قیمت کل اجناس
                                                </div>

                                                <div></div>
                                                {toPersianNumber(
                                                    o.totalItemsPrice || 0,
                                                    true
                                                )}
                                            </div>
                                            <div className='postalCost text primary'>
                                                <div className='text info'>
                                                    هزینه پست
                                                </div>

                                                <div></div>
                                                {toPersianNumber(
                                                    o.shipping_cost || 0,
                                                    o.shipping_cost ===
                                                        "پس کرایه"
                                                        ? false
                                                        : true
                                                )}
                                            </div>
                                            <div className='packingCost text primary'>
                                                <div className='text info'>
                                                    هزینه بسته بندی
                                                </div>

                                                <div></div>
                                                {toPersianNumber(
                                                    o.packingPrice || 0,
                                                    true
                                                )}
                                            </div>
                                            <div className='totalPrice text primary'>
                                                <div className='text info'>
                                                    قیمت کل
                                                </div>

                                                <div></div>
                                                {toPersianNumber(
                                                    o.total || 0,
                                                    true
                                                )}
                                            </div>
                                        </div>
                                        <div className='actions'>
                                            <div className='status'>
                                                {o.status === "pending"
                                                    ? "در انتظار پردازش"
                                                    : o.status === "notPayed"
                                                    ? "پرداخت نشده"
                                                    : o.status === "sent"
                                                    ? "ارسال شده"
                                                    : o.status}
                                            </div>
                                            <div className='totalPrice text primary'>
                                                {toPersianNumber(
                                                    o.total || 0,
                                                    true
                                                )}
                                            </div>
                                            <div className='note'>{o.note}</div>

                                            <button
                                                onClick={(e) =>
                                                    this.deletOrder(o.id, true)
                                                }
                                                className='delete btn danger'
                                            >
                                                <i className='ri-delete-bin-5-line'></i>
                                                {`حذف سفارش${
                                                    o.status != "sent"
                                                        ? " و آزادسازی کالای رزرو"
                                                        : ""
                                                }`}
                                            </button>

                                            <button
                                                onClick={(e) =>
                                                    this.deletOrder(o.id, false)
                                                }
                                                className='delete btn warning flex flex-row items-center text-black font-thin'
                                            >
                                                <i className='ri-delete-bin-4-line text-black '></i>
                                                {`حذف سفارش بدون آزادسازی کالا ها`}
                                            </button>

                                            <button
                                                onClick={(e) =>
                                                    this.printOrder(o)
                                                }
                                                className='btn info'
                                            >
                                                <i className='ri-printer-fill'></i>
                                                چاپ
                                            </button>
                                            {(o.status == "pending" ||
                                                o.status == "sent") && (
                                                <div className='sent'>
                                                    <input
                                                        type='text'
                                                        placeholder=' کد رهگیری پستی'
                                                        defaultValue={
                                                            o.tracking_code
                                                        }
                                                        onChange={(ev) =>
                                                            (tracking_code =
                                                                ev.target.value)
                                                        }
                                                    />
                                                    <button
                                                        onClick={(ev) =>
                                                            this.update_order_status(
                                                                o.id,
                                                                tracking_code
                                                            )
                                                        }
                                                        className='sent btn confirm'
                                                    >
                                                        {o.status == "sent"
                                                            ? o.tracking_code
                                                                ? "تغیر کد رهگیری"
                                                                : "ثبت کد رهگیری"
                                                            : "سفارش ارسال شد"}
                                                    </button>
                                                </div>
                                            )}
                                            {o.status == "sent" &&
                                                o.tracking_code && (
                                                    <div className='postalTackCode'>
                                                        کد رهگیری
                                                        {o.tracking_code}
                                                    </div>
                                                )}

                                            {o.time && (
                                                <div className='orderTime'>
                                                    {new Date(
                                                        o.time
                                                    ).toLocaleString("fa-IR")}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className='bottom'>
                                        <div className='payment'>
                                            <div className='method text primary'>
                                                <div className='name text info'>
                                                    نوع پرداخت :{" "}
                                                </div>
                                                <div className='value text primary'>
                                                    {o.payment === "offline" &&
                                                        "آفلاین"}
                                                    {o.payment === "online" &&
                                                        "آنلاین"}
                                                    {o.payment === "online" && (
                                                        <button
                                                            className='refresh btn warning'
                                                            onClick={(ev) => {
                                                                this.verify_online_payment(
                                                                    o.id
                                                                );
                                                            }}
                                                        >
                                                            بررسی
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                            {o.payment === "offline" &&
                                                (o.status === "pending" ||
                                                    o.status === "sent") && (
                                                    <div className='info offline'>
                                                        {o.payment_info &&
                                                            o.payment_info
                                                                .entries && (
                                                                <table className='entry'>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>
                                                                                روش
                                                                            </th>
                                                                            <th>
                                                                                مقدار
                                                                            </th>
                                                                            <th>
                                                                                رهگیری
                                                                            </th>
                                                                            <th>
                                                                                به
                                                                                نام
                                                                            </th>
                                                                            <th>
                                                                                توضیحات
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {o.payment_info.entries.map(
                                                                            (
                                                                                entry,
                                                                                index
                                                                            ) => {
                                                                                return (
                                                                                    <tr
                                                                                        key={
                                                                                            index
                                                                                        }
                                                                                    >
                                                                                        <td className='method'>
                                                                                            {entry.method ===
                                                                                                "card" &&
                                                                                                "کارت به کارت"}
                                                                                            {entry.method ===
                                                                                                "paya" &&
                                                                                                "پایا"}
                                                                                            {entry.method ===
                                                                                                "account" &&
                                                                                                "حساب به حساب"}
                                                                                        </td>
                                                                                        <td className='amount'>
                                                                                            {toPersianNumber(
                                                                                                entry.amount ||
                                                                                                    "",
                                                                                                true
                                                                                            )}
                                                                                        </td>
                                                                                        <td className='tracking'>
                                                                                            {
                                                                                                entry.tracking
                                                                                            }
                                                                                        </td>
                                                                                        <td className='name'>
                                                                                            {
                                                                                                entry.name
                                                                                            }
                                                                                        </td>
                                                                                        <td className='comment'>
                                                                                            {
                                                                                                entry.comment
                                                                                            }
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            }
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            )}
                                                    </div>
                                                )}

                                            {o.payment === "online" &&
                                                (o.status === "pending" ||
                                                    o.status === "sent") && (
                                                    <div className='info online'>
                                                        {o.payment_info &&
                                                            o.payment_info
                                                                .verification && (
                                                                <table className='entry'>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>
                                                                                مقدار
                                                                            </th>
                                                                            <th>
                                                                                شماره
                                                                                مرجع
                                                                            </th>
                                                                            <th>
                                                                                شماره
                                                                                کارت
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>
                                                                                {toPersianNumber(
                                                                                    o
                                                                                        .payment_info
                                                                                        .verification
                                                                                        .amount /
                                                                                        10,
                                                                                    true
                                                                                )}
                                                                            </td>
                                                                            <td>
                                                                                {toPersianNumber(
                                                                                    o
                                                                                        .payment_info
                                                                                        .verification
                                                                                        .ref_id
                                                                                )}
                                                                            </td>
                                                                            <td>
                                                                                {toPersianNumber(
                                                                                    o
                                                                                        .payment_info
                                                                                        .verification
                                                                                        .card_pan
                                                                                )}
                                                                            </td>
                                                                            <td>
                                                                                <button
                                                                                    className='btn info'
                                                                                    onClick={(
                                                                                        ev
                                                                                    ) => {
                                                                                        this.verify_online_payment(
                                                                                            o.id
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    استعلام
                                                                                    تراکنش
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            )}
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                </div>
                {total && page !== null && count && (
                    <Pagination
                        count={count}
                        page={page}
                        total={total}
                        on_page_change={(p) => this.on_page_change(p)}
                    />
                )}
            </div>
        );
    }
}

export default withRouter(Orders);
